const HistoryStatus = Object.freeze({
    CREATE: ("Создание"),                            // создание проекта
    DELETE: ("Удаление"),                            // удаление проекта
    UPDATE: ("Изменение"),                           // изменение проекта
    STATUS: ("Изменение стутуса"),                   // изменение тсатуса проекта
    TRANSACTION_CREATE: ("Запрос на создание"),     // получение запроса на создание проекта
    TRANSACTION_APPROVE: ("Утверждение"),            // утверждение запроса
    TRANSACTION_DECLINE: ("Отклонение"),             // отклоенине запроса
    TRANSACTION_DELETE: ("Запрос на удаление"),      // получение запроса на удаление проекта
    TRANSACTION_UPDATE: ("Запрос на изменение"),     // получение запроса на изменение проекта
    TRANSACTION_CHANGE: ("Изменение запроса"),
});

const HistoryStatusColor = Object.freeze({
    CREATE: ("blue"),                            // создание проекта
    DELETE: ("red"),                            // удаление проекта
    UPDATE: ("orange"),                           // изменение проекта
    STATUS: ("orange"),                   // изменение тсатуса проекта
    TRANSACTION_CREATE: ("blue"),     // получение запроса на создание проекта
    TRANSACTION_APPROVE: ("green"),            // утверждение запроса
    TRANSACTION_DECLINE: ("red"),             // отклоенине запроса
    TRANSACTION_DELETE: ("red"),      // получение запроса на удаление проекта
    TRANSACTION_UPDATE: ("green"),     // получение запроса на изменение проекта
    TRANSACTION_CHANGE: ("orange"),
});

export { HistoryStatus, HistoryStatusColor };